import type { OthersEntity } from '../../others/Others.entity';
import type { TRenderScreen, TSettingsScreenOptions } from '../SettingsScreenRendererService';

import { OthersScreen } from '../../others/OthersScreen';

export function renderOthersScreen(screen: OthersEntity, options: TSettingsScreenOptions): TRenderScreen {
  return () => <OthersScreen stack={options.stack} screen={screen} />;
}
